<template>
    <div class="short-cut-comp">
        <div class="list">
            <div class="item" v-for="(item, index) in shortCutList" :key="index" @click="$router.push({name: item.linkName})">
                <div class="title">
                    {{item.title}}
                    <img src="@/assets/img/icon/arror_right_gray.svg" alt="">
                </div>
                <div class="content">
                    {{item.content}}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {
            shortCutList: [
                {
                    title: '刊登廣告',
                    content: '建立一筆您的房源資料，建立完成後將可以上架到飛豬找房，讓房客可以線上預訂',
                    linkName: 'bizAddHouse'
                },
                {
                    title: '新增記帳',
                    content: '建立房源的記帳，記帳分成支出、收入與代墊，有設定房東的房源，才能新增代墊。若房源有設定房東，記帳此房源的：收入、支出項目中的給屋主押金、代墊的報價金額將會寫入屋主對帳單，其餘則不會。',
                    linkName: 'ledgerMgt'
                },
                {
                    title: '新增委託',
                    content: '向您的房客發起委託，請房客幫您帶看房子。委託需要設定時間與獎金，獎金會在新房客入住時自動撥款給原房客',
                    linkName: 'bizNewTask'
                },
                {
                    title: '建立房東',
                    content: '建立物件的房東，您可以在建立房源時一併建立房東，也能選擇已經建立好的房東。系統將在每月初自動生成屋主報表，提供您Excel跟屋主對帳。',
                    linkName: 'bizAddLandlord'
                },
                {
                    title: '報表概覽',
                    content: '彙整飛豬代收、記帳收支、代墊欠款與其他額外收入與支出的統計報表',
                    linkName: 'bizReportOverview'
                },
                {
                    title: '簽署合約',
                    content: '您在飛豬管家建立的房源，上架後會在飛豬找房讓房客搜尋到。雙方能直接在線上預訂並簽約',
                    linkName: 'bizBookingMgtDefault'
                },
                {
                    title: '批次刊登廣告',
                    content: '下載飛豬管家-企業版專屬Excel，透過批次上傳輕鬆解決建立房源',
                    linkName: 'bizBatchUpload'
                },
                {
                    title: '建立紙本合約',
                    content: '此情境用於您現在已經跟房客有紙本合約，將線下收租模式改由線上收租',
                    linkName: 'bizNewPaperContract'
                },
            ]
        }
    }
}
</script>
<style lang="scss" scoped>
    .short-cut-comp{
        width: 1140px;
        height: 641px;
        padding: 24px;
        border-radius: 6px;
        box-sizing: border-box;
        background: #fff;
        .list{
            display: flex;
            flex-wrap: wrap;
            .item{
                width: 350px;
                height: 152px;
                border-radius: 4px;
                border: solid 1px #f3f3f3;
                background-color: #ffffff;
                padding: 12px 15px;
                box-sizing: border-box;
                margin-right: 20px;
                margin-bottom: 20px;
                cursor: pointer;
                &:nth-child(3n){
                    margin-right: 0px;
                }
                .title{
                    display: flex;
                    align-items: center;
                    font-size: 16px;
                    font-weight: 500;
                    margin-bottom: 4px;
                }
                .content{
                    color: #676362;
                    line-height: 1.5;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/personalHome/home/shortCut/shortCutComp.vue